import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, onMounted, reactive, ref, toRef, watch } from 'vue'
import { getPda, postPda, putPda, putPdaStatus } from '@/api/storage/pda'
import { message } from 'ant-design-vue';
import { clone } from 'sortablejs';

export default /*#__PURE__*/_defineComponent({
  __name: 'pda',
  props: {
    pdaData: null,
    visible: null
  },
  emits: ['cannel', 'show'],
  setup(__props: any, { emit }) {

const props = __props as {
    pdaData: any;
    visible: any;
};

const md5 = require('blueimp-md5');


const is_loading = ref(false)
const model_layout: any = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 },
};
// const visible = ref<boolean>(true)
const accountVisible = ref<boolean>(false)
const pda_table_data = ref({
    current: 1,
    last: 0,
    total: 0,
    limit: 10,
    detail: []
})
// eslint-disable-next-line no-undef

// eslint-disable-next-line no-undef

const visible = toRef(props, 'visible')
const pdaData = toRef(props, 'pdaData')

const accountData = reactive({
    name: '',
    password: ''
})
const accountStatus = ref(false)
const pda_columns = ref([
    {
        title: '账户名称',
        dataIndex: 'name',
        key: 'name',
        width: '13%',
    },
    {
        title: '创建人',
        dataIndex: 'creator_name',
        key: 'creator_name',
        width: '13%',
    },
    {
        title: '创建时间',
        dataIndex: 'create_time',
        key: 'create_time',
        width: '13%',
        scopedSlots: {
            customRender: 'create_time',
        },
    },
    {
        title: '操作',
        dataIndex: 'status',
        key: 'status',
        width: '13%',
        scopedSlots: {
            customRender: 'status',
        },
    },
])
const pdaId = ref()
async function changeStatus(value: any) {
    const send_data = {
        status: value.status === 1 ? 2 : 1
    }
    const res = await putPdaStatus(send_data, value.id)
    if (res.status === 200) {
        message.success('PDA权限状态更改成功')
        getTableList()
    } else {
        message.error("PDA权限状态更改失败")
    }


}
async function edit(data: any) {
    accountStatus.value = true
    emit('cannel')
    accountVisible.value = true
    accountData.name = data.name
    pdaId.value = data.id
}
async function accountHandleOk() {

    if (accountData.name === '') return message.error('请输入账号名称')
    if (accountData.password === '' || accountData.password.length < 6) return message.error('请输入正确格式的密码')
    const send_data = JSON.parse(JSON.stringify({
        name: accountData.name,
        password: md5(accountData.password),
        type: pdaData.value.type,
        warehouse_id: pdaData.value.type === 2 ? pdaData.value.id : 0,
        factory_id: pdaData.value.type === 1 ? pdaData.value.id : 0,
    }))

    let res

    if (accountStatus.value) {

        res = await putPda(send_data, pdaId.value)
    } else {
        res = await postPda(send_data)
    }
    if (res.status === 200) {
        // eslint-disable-next-line require-atomic-updates
        accountData.name = ''
        // eslint-disable-next-line require-atomic-updates
        accountData.password = ''
        emit('show')
        accountVisible.value = false
        getTableList()
        message.success(accountStatus.value ? '编辑账号成功' : '新建账号成功')
    } else {
        message.error((res as any).message)

    }

}
function accountHandleCancel() {
    accountData.name = ''
    accountData.password = ''
    emit('show')
    accountVisible.value = false
}
function paginationOption(data: any) {
    return {
        current: data.current || 0,
        pageSize: data.limit || 0,
        showTotal: () => `共${data.total}条, 每页${data.limit}条`,
        total: data.total || 0,
    };
}
function add() {
    accountStatus.value = false
    emit('cannel')
    accountVisible.value = true
}
function handleTableChange(paginationa: any) {
    getTableList(paginationa.current)
}
function handleCancel() {
    emit('cannel')
}
async function getTableList(current: number = 1) {
    is_loading.value = true
    const type_id = props.pdaData.type ===1 ? "factory_id":"warehouse_id"
    const res = await getPda({ type: props.pdaData.type ,[type_id]:props.pdaData.id}, current)
    pda_table_data.value = res.data
    is_loading.value = false
}

let watchPda 
onMounted(()=>{
    watchPda = watch([()=>props.pdaData.id,()=>props.pdaData.type] ,([val,typeVal])=>{
        getTableList()
    })
})
onBeforeUnmount(()=>{
    watchPda()
})

return { __sfc: true,md5, is_loading, model_layout, accountVisible, pda_table_data, emit, props, visible, pdaData, accountData, accountStatus, pda_columns, pdaId, changeStatus, edit, accountHandleOk, accountHandleCancel, paginationOption, add, handleTableChange, handleCancel, getTableList, watchPda }
}

})